import { render, staticRenderFns } from "./PhotoEvidence.vue?vue&type=template&id=520ae4a0&"
import script from "./PhotoEvidence.vue?vue&type=script&lang=js&"
export * from "./PhotoEvidence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports